import { AnalyticsEventName } from '@dupe/common/constants'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { toast } from 'sonner'
import DupeDiscoverPreview from '~/src/components/DupeDiscoverPreview'
import DupeHero from '~/src/components/DupeHero'
import Layout from '~/src/components/Layout'
import LayoutFullHeader from '~/src/components/LayoutFullHeader'
import HomepageInput from '~/src/components/home/HomepageInput'
import GetPaidModal from '~/src/components/rewards/GetPaidModal'
import useAnalytics from '~/src/hooks/useAnalytics'
import { cn } from '~/src/lib/utils'

const HomeCategorySelector = dynamic(
  () => import('~/src/components/home/HomeCategorySelector'),
  {
    ssr: false,
  }
)

const IndexHome: React.FC = () => {
  const analytics = useAnalytics()
  const router = useRouter()
  const hasError = router.query.error
  const isInvalidUrl = hasError && hasError === 'invalid-url'

  // Show error toast if invalid URL
  useEffect(() => {
    if (isInvalidUrl) {
      toast.error('Invalid URL', {
        description: (
          <div className='dark:text-white'>
            Please enter a full product URL and try again.
          </div>
        ),
      })

      // remove the error from the query
      router.replace('/', undefined, { shallow: true })
    }
  }, [isInvalidUrl, router])

  // trigger analytics event for HomepageViewed
  useEffect(() => {
    analytics.track(AnalyticsEventName.HomepageViewed)
    // The `analytics` object causes this useEffect to
    // run multiple times, so we exclude it from the dependencies.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout
      fullWidth
      hideHeader
      hideBorders
      backgroundTheme='#000000'
      className='bg-black dark:bg-black'
      headerClassName='bg-black dark:bg-black'
      mainClassName='bg-black dark:bg-black text-white dark:text-white'
      inputClassName='bg-black dark:bg-black'
    >
      <LayoutFullHeader sticky transparent />

      <div className='relative min-h-screen bg-black'>
        <DupeDiscoverPreview forceAnimation>
          <HomeContent />
        </DupeDiscoverPreview>
      </div>

      <HomeCategorySelector />
      <GetPaidModal />
    </Layout>
  )
}

const HomeContent: React.FC = () => {
  return (
    <div
      className={cn(
        'pointer-events-none sticky top-0 z-10 flex min-h-[100dvh] w-full flex-col items-center md:min-h-screen',
        'flex flex-col justify-center'
      )}
    >
      <div className='flex w-full max-w-screen-sm flex-col space-y-8 px-3 lg:max-w-screen-md'>
        <DupeHero forceTheme={'dark'} className='text-white' />
        <div className='min-h-[186px]'>
          <HomepageInput />
        </div>
      </div>
    </div>
  )
}

export default IndexHome
